<template>
  <div class="chip" @click="onChipSelected">
    <img v-if="image" alt="small icon" class="icon" :src="image" />
    <div class="title" :class="secondaryText ? 'color' : ''">
      <div class="title-name">
        {{ label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    secondaryText: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChipSelected() {
      this.$emit('chip-selected', this.label)
    },
  },
}
</script>

<style scoped lang="scss">
.chip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;
  background: var(--bg-2);
  cursor: pointer;
  transition: 200ms ease;
  border: 1px solid var(--bg-35);
  flex-basis: max-content;
  flex-grow: 1;
  flex-shrink: 0;
  width: 60px;

  &:hover {
    background: var(--bg-4);
  }
}

.icon {
  max-width: 18px;
  margin-right: 5px;
}

.title-name {
  font-size: 14px;
  font-weight: 500;
  text-align: start;
}

.color {
  color: var(--text-4);
}
</style>
